import PropTypes from 'prop-types';
import React from 'react';
import Pill from './Pill';
import { getComponentClasses } from '@99designs/utils/app';
import autoFocus from '../lib/hoc/autoFocus';
import deprecated from '../lib/deprecated';

export default function MenuItemAction(Component) {
    const PreparedComponent = autoFocus(Component);

    class MenuItemAction extends React.Component {
        icon() {
            if (this.props.icon) {
                return <span className="menu__item__action__icon">{this.props.icon}</span>;
            }
        }

        count() {
            if (this.props.count !== undefined) {
                return (
                    <small className="menu__item__action__label__small">
                        {'(' + this.props.count + ')'}
                    </small>
                );
            }
        }

        notification() {
            let notification = this.props.notification;
            if (this.props.counter) {
                deprecated('MenuItemAction prop counter is deprecated, use notification instead');
                notification = this.props.counter;
            }
            if (notification) {
                return (
                    <span className="menu__item__action__pill">
                        <Pill variations={['notification', 'small']}>{notification}</Pill>
                    </span>
                );
            }
        }

        variations() {
            const variations = this.props.variations.slice();

            if (this.props.isSelected) {
                variations.push('selected');
            }

            if (Boolean(this.props.icon)) {
                variations.push('has-icon');
            }

            if (this.props.counter > 0) {
                variations.push('has-pill');
            }

            return variations;
        }

        render() {
            const attrs = [];
            if (this.props.isDisabled) {
                attrs['data-disabled'] = true;
            }
            return (
                <li
                    className={getComponentClasses('menu__item__action', this.variations())}
                    role="menuitem"
                    onKeyDown={this.onKeyDown}
                    onBlur={this.props.onBlur}
                    onKeyDown={this.props.onKeyDown}
                    {...attrs}
                >
                    <PreparedComponent
                        tabIndex="0"
                        isFocused={this.props.isFocused}
                        url={this.props.url}
                        onSelect={this.props.onSelect}
                        onClick={this.props.onClick}
                        anchorProps={this.props.anchorProps}
                    >
                        {this.icon()}
                        <span className="menu__item__action__label">
                            {this.label()}
                            {this.count()}
                        </span>
                        {this.notification()}
                    </PreparedComponent>
                </li>
            );
        }

        label() {
            return this.props.label ? this.props.label : this.props.children;
        }
    }

    MenuItemAction.propTypes = {
        icon: PropTypes.element,
        label: PropTypes.string,
        counter: PropTypes.number, // Deprecated
        notification: PropTypes.number,
        count: PropTypes.number,
        url: PropTypes.string,
        isFocused: PropTypes.bool,
        isSelected: PropTypes.bool,
        isTargetBlank: PropTypes.bool,
        isDisabled: PropTypes.bool,
        variations: PropTypes.array,
        onBlur: PropTypes.func,
        onClick: PropTypes.func,
        onSelect: PropTypes.func,
        onKeyDown: PropTypes.func,
        anchorProps: PropTypes.object,
    };

    MenuItemAction.defaultProps = {
        variations: [],
        isFocused: false,
        isSelected: false,
        isTargetBlank: false,
        isDisabled: false,
        onBlur() {},
        onSelect() {},
        onKeyDown() {},
        anchorProps: {},
    };

    return MenuItemAction;
}



// WEBPACK FOOTER //
// ./~/@99designs/react-components/components/MenuItemAction.jsx